<div
  *ngIf="
    ((cartItemCount$ | async) || (cartItemCountUnauthenticated$ | async)) &&
      !(configurationService.isTabletOrLarger$ | async) &&
      (showCartInMobile$() | async);
    else normalCart
  "
  class="dropdown"
  dropdown
>
  <button
    type="button"
    dropdownToggle
    aria-controls="dropdown-alignment"
    class="btn btn-cart-item"
    [ngClass]="
      (cartItemCount$ | async) > 0 ||
      (cartItemCountUnauthenticated$ | async) > 0
        ? 'btn-primary'
        : 'btn-soft-secondary'
    "
    data-test-id="cart-items"
    (click)="navigateToCart()"
  >
    <i
      class="fas fa-shopping-cart"
      attr.aria-label="{{ 'wcag.shoppingCart' | translate }}"
      role="img"
    ></i>
    <span data-test-id="cart-items-cart">
      <span
        class="badge bg-light"
        *ngIf="cartItemCount$ | async as cartItemCount"
        data-test-id="cart-items-count"
        [attr.data-test-id-cart-count]="cartItemCount"
        attr.aria-label="{{ 'wcag.itemsInCart' | translate }} {{
          cartItemCount
        }}"
        aria-atomic="true"
      >
        {{ cartItemCount }}
      </span>
      <span
        class="badge bg-light"
        *ngIf="
          cartItemCountUnauthenticated$ | async as cartItemCountUnauthenticated
        "
        data-test-id="cart-items-count"
        [attr.data-test-id-cart-count]="cartItemCountUnauthenticated"
      >
        {{ cartItemCountUnauthenticated }}
      </span>
    </span>
  </button>
</div>

<ng-template #normalCart>
  <div class="position-relative dropdown" dropdown>
    <button
      type="button"
      dropdownToggle
      aria-controls="dropdown-alignment"
      class="btn btn-cart-item d-none d-lg-inline"
      data-test-id="cart-items"
      [ngClass]="
        (cartItemCount$ | async) > 0 ||
        (cartItemCountUnauthenticated$ | async) > 0
          ? 'btn-primary'
          : 'btn-soft-secondary'
      "
    >
      <i
        class="fas fa-shopping-cart"
        attr.aria-label="{{ 'wcag.shoppingCart' | translate }}"
        role="img"
      ></i>
      <span data-test-id="cart-items-cart">
        <span
          class="badge bg-light"
          *ngIf="cartItemCount$ | async as cartItemCount"
          data-test-id="cart-items-count"
          [attr.data-test-id-cart-count]="cartItemCount"
          attr.aria-label="{{ 'wcag.itemsInCart' | translate }} {{
            cartItemCount
          }}"
          aria-atomic="true"
        >
          {{ cartItemCount }}
        </span>
        <span
          class="badge bg-light"
          *ngIf="
            cartItemCountUnauthenticated$
              | async as cartItemCountUnauthenticated
          "
          data-test-id="cart-items-count"
          [attr.data-test-id-cart-count]="cartItemCountUnauthenticated"
        >
          {{ cartItemCountUnauthenticated }}
        </span>
      </span>
    </button>

    <ul
      *dropdownMenu
      class="dropdown-menu dropdown-menu-end p-3"
      style="min-width: 275px"
      role="menu"
    >
      <li
        *ngIf="
          (cartItemCount$ | async) === 0 &&
          (cartItemCountUnauthenticated$ | async) === 0
        "
      >
        <figure class="mx-auto mb-3" style="max-width: 6rem">
          <img
            class="img-fluid"
            src="assets/svg/illustrations/empty-cart.svg"
            alt="{{ 'cartModule.yourCartIsEmpty' | translate }}"
          />
        </figure>
        <div data-test-id="cart-is-empty">
          {{ 'cartModule.yourCartIsEmpty' | translate }}
        </div>
      </li>
      <ng-container *ngIf="cartItemCount$ | async">
        <ng-container *ngFor="let cartItem of cartItems$ | async">
          <li
            class="d-flex justify-content-between pb-2"
            *ngIf="
              cartItem.params?.bookableLinkedProductId || cartItem.productId
            "
          >
            <span
              *ngIf="cartItem.params?.bookableLinkedProductId; else normalBlock"
            >
              {{
                cartItem.params?.bookableLinkedProductId
                  | getTranslation: 'product' : 'description'
                  | async
              }}

              <span class="small">
                {{
                  cartItem.params?.bookableProductId
                    | getTranslation: 'product' : 'description'
                    | async
                }}
                -
                {{
                  cartItem.params?.startDate
                    | formatDate: 'EE d MMM HH:mm'
                    | async
                }}
              </span>
            </span>
            <ng-template #normalBlock>
              <span *ngIf="cartItem.type == 'product'">
                {{
                  cartItem.productId
                    | getTranslation: 'product' : 'description'
                    | async
                }}
              </span>
              <span *ngIf="cartItem.type == 'ticket'">
                {{
                  (cartItem.category
                  | customerCategoryName
                    : (productEntities$ | async)[cartItem.productId]?.siteId
                  | async)
                    ? (cartItem.category
                      | customerCategoryName
                        : (productEntities$ | async)[cartItem.productId]?.siteId
                      | async)
                    : (cartItem.productId
                      | getTranslation: 'product' : 'description'
                      | async)
                }}
                {{
                  cartItem.productId
                    | getTranslation: 'product' : 'description'
                    | async
                }}
              </span>
            </ng-template>
            <span class="small text-nowrap" *ngIf="cartItem.type == 'product'">
              {{
                cartItem.amount *
                  ((cartItemService.getCartItemPrice$(cartItem, 'total')
                    | async) +
                    getCartItemBasePrice(cartItem)) | currency
              }}
            </span>
            <span class="small text-nowrap" *ngIf="cartItem.type == 'ticket'">
              {{
                cartItem.amount *
                  ((cartItemService.getCartItemPrice$(cartItem) | async) +
                    getCartItemBasePrice(cartItem)) | currency
              }}
            </span>
          </li>
          <li
            class="d-flex justify-content-between pb-2"
            *ngIf="cartItem.subscriptionId"
          >
            <span>
              {{
                cartItem.subscriptionId
                  | getTranslation: 'subscription' : 'description'
                  | async
              }}
            </span>
            <span class="small text-nowrap">
              {{
                (subscriptionEntities$ | async)[cartItem.subscriptionId]
                  | subscriptionPriceForMember: cartItem.params
                  | async
                  | currency
              }}
            </span>
          </li>
          <li
            class="d-flex justify-content-between pb-2"
            *ngIf="cartItem.courseId"
          >
            <span>
              {{
                cartItem.productId
                  | getTranslation: 'product' : 'description'
                  | async
              }}
            </span>
            <span class="small text-nowrap">
              {{
                (courseEntities$ | async)[cartItem.courseId]
                  | coursePriceForMember: cartItem.params
                  | async
                  | currency
              }}
            </span>
          </li>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="cartItemCountUnauthenticated$ | async">
        <ng-container
          *ngFor="let cartItem of cartItemsUnauthenticated$ | async"
        >
          <li class="list-group-item text-body" *ngIf="cartItem.productId">
            <span
              *ngIf="cartItem.params?.bookableLinkedProductId; else normalBlock"
            >
              {{
                cartItem.params?.bookableLinkedProductId
                  | getTranslation: 'product' : 'description'
                  | async
              }}

              <span class="small d-block">
                {{
                  cartItem.params?.bookableProductId
                    | getTranslation: 'product' : 'description'
                    | async
                }}
                -
                {{
                  cartItem.params?.startDate
                    | formatDate: 'EE d MMM HH:mm'
                    | async
                }}
              </span>
            </span>
            <ng-template #normalBlock>
              <span>
                {{
                  cartItem.productId
                    | getTranslation: 'product' : 'description'
                    | async
                }}
              </span>
            </ng-template>
            <span class="small text-nowrap">
              {{
                (productEntities$ | async)[
                  cartItem.params?.bookableLinkedProductId
                    ? cartItem.params?.bookableLinkedProductId
                    : cartItem.productId
                ]
                  | productPriceForMember: cartItem.params
                  | async
                  | currency
              }}
            </span>
          </li>

          <li class="list-group-item text-body" *ngIf="cartItem.courseId">
            <span>
              {{
                cartItem.productId
                  | getTranslation: 'product' : 'description'
                  | async
              }}
            </span>
            <span class="small text-nowrap">
              {{
                (courseEntities$ | async)[cartItem.courseId]
                  | coursePriceForMember: cartItem.params
                  | async
                  | currency
              }}
            </span>
          </li>
        </ng-container>
      </ng-container>

      <ng-container
        *ngIf="
          (cartItemCount$ | async) !== 0 ||
          (cartItemCountUnauthenticated$ | async) !== 0
        "
      >
        <li class="dropdown-divider"></li>

        <li class="d-flex justify-content-between align-items-center mb-3">
          <div class="me-3 fw-bold">
            {{ 'general.total' | translate }}
          </div>
          <div
            class="flex-grow-1 text-end text-dark fw-bold"
            *ngIf="cartItemsTotal$ | async"
          >
            {{ cartItemsTotal$ | async | currency }}
          </div>
          <div
            class="flex-grow-1 text-end text-dark fw-bold"
            *ngIf="cartItemCountUnauthenticated$ | async"
          >
            {{
              cartItemService.getUnauthenticatedCartItemTotal$()
                | async
                | currency
            }}
          </div>
        </li>
        <li>
          <a
            class="btn btn-primary w-100 transition-3d-hover"
            routerLink="/cart"
            data-test-id="button-checkout"
            href="javascript:;"
          >
            {{ 'saleModule.checkout' | translate }}
          </a></li
        >
      </ng-container>
    </ul>
  </div>
</ng-template>
